export const COLLAPSED_BAR = 'COLLAPSED_BAR';
export const ACTIVE_NAV = 'ACTIVE_NAV'
